import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import soleToSoleLogo from "@/assets/sole-to-sole-logo.png";

const TikTokIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} width="20" height="20">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.7a8.16 8.16 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.13z" />
  </svg>
);

const ThreadsIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} width="20" height="20">
    <path d="M17.39 11.13c-.09-.04-.18-.08-.27-.12-.16-2.93-1.76-4.61-4.45-4.63h-.04c-1.61 0-2.95.69-3.78 1.94l1.48 1.02c.62-.94 1.59-1.14 2.3-1.14h.03c.88.01 1.55.27 1.97.77.31.36.52.86.62 1.49-.78-.13-1.62-.17-2.52-.12-2.54.15-4.17 1.63-4.06 3.69.06 1.04.58 1.94 1.46 2.53.74.5 1.7.74 2.69.69 1.31-.07 2.34-.57 3.06-1.49.55-.7.89-1.61 1.05-2.76.65.39 1.13.91 1.4 1.53.45 1.06.48 2.79-.94 4.21-1.24 1.24-2.74 1.78-5 1.79-2.5-.02-4.39-.82-5.62-2.38-1.15-1.46-1.75-3.57-1.77-6.27.02-2.7.62-4.81 1.77-6.27 1.23-1.56 3.12-2.36 5.62-2.38 2.52.02 4.44.83 5.71 2.4.62.77 1.09 1.74 1.4 2.87l1.79-.48c-.38-1.39-.97-2.59-1.78-3.59C16.94 1.04 14.6.02 11.59 0H11.58C8.58.02 6.27 1.05 4.72 3.06 3.34 4.85 2.62 7.34 2.6 10.46v.02c.02 3.12.74 5.61 2.12 7.4 1.55 2.01 3.86 3.04 6.86 3.06h.01c2.66-.02 4.54-.72 6.09-2.27 2.02-2.02 1.96-4.55 1.29-6.11-.48-1.12-1.4-2.03-2.66-2.62zm-4.62 4.18c-1.09.06-2.23-.43-2.29-1.49-.04-.78.56-1.66 2.36-1.76.21-.01.41-.02.61-.02.65 0 1.27.06 1.83.18-.21 2.62-1.43 3.03-2.51 3.09z" />
  </svg>
);

const RedditIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} width="20" height="20">
    <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 0-.462.342.342 0 0 0-.461 0c-.545.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.345.345 0 0 0-.206-.095z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={soleToSoleLogo} alt="Sole to Sole Logo" width={40} height={40} className="w-10 h-10 rounded-lg object-contain" />
              <span className="font-heading font-semibold text-lg tracking-tight">SOLE TO SOLE</span>
            </Link>
            <p className="text-muted-foreground text-sm">
              Sole To Sole is a Dallas-based sneaker buy, sell, and trade event and marketplace at Dallas Market Hall.
            </p>
            <p className="text-muted-foreground text-xs mt-1">Dallas, Texas</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/events" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Browse Events
              </Link>
              <Link to="/apply" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Become a Vendor
              </Link>
              <Link to="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                About Us
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4">Contact</h4>
            <p className="text-sm text-muted-foreground">
              support@soletosole.com
            </p>
            <div className="flex flex-col gap-2 mt-3">
              <a
                href="https://www.instagram.com/soletosole/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                <Instagram className="w-5 h-5" />
                @soletosole
              </a>
              <a
                href="https://www.tiktok.com/@sole.to.sole8?_r=1&_t=ZT-95UhQktPErO"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                <TikTokIcon className="w-5 h-5" />
                TikTok
              </a>
              <a
                href="https://youtube.com/@soletosole-x1u?si=fobLlKBWRivdWO_H"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                <Youtube className="w-5 h-5" />
                YouTube
              </a>
              <a
                href="https://www.facebook.com/share/1J7YJuRAf1/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                <Facebook className="w-5 h-5" />
                Facebook
              </a>
              <a
                href="https://www.threads.com/@soletosole?igshid=NTc4MTIwNjQ2YQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                <ThreadsIcon className="w-5 h-5" />
                Threads
              </a>
              <a
                href="https://www.reddit.com/u/SoleToSole_Tradeshow/s/dCBys19Lrt"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                <RedditIcon className="w-5 h-5" />
                Reddit
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 flex flex-col items-center gap-3">
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <span className="text-muted-foreground/40">|</span>
            <Link to="/terms" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Sole to Sole. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;